import { Component, OnInit } from '@angular/core';
import { ThemingService, ShopTheming } from 'src/app/theming.service';
import { LambdaService } from 'src/app/lambda.service';
declare var $: any;
@Component({
  selector: 'app-email-template-editor',
  templateUrl: './email-template-editor.component.html',
  styleUrls: ['./email-template-editor.component.scss']
})
export class EmailTemplateEditorComponent implements OnInit {

  public shopTheme: ShopTheming[] = [];
  private _originalTemplate: any = null;
  public templateData: any = {};
  public orderNumber = 'Order #12345';
  public total       = '$200.00';
  public requestDate = '2025-06-30';
  loading = false;
  public showErrors = false;
  public logoUrl = '';
  public product = {
    image:    'https://mobydyg-files.s3.us-east-1.amazonaws.com/mainlogo-mobydyg.png',
    name:     'Item 1',
    extra:    'Size: Medium',
    price:    '$100.00',
    quantity: '2',
    link:     'https://example.com/product1.pdf'
  };

  constructor(
    private themingService: ThemingService,
    private lambdaService: LambdaService
  ) {
    this.shopTheme = this.themingService.shopTheming;
  }

  ngOnInit(): void {
    this.shopTheme = this.themingService.shopTheming;
    this.getTemplateData();
  }

  async getTemplateData(): Promise<void> {
    this.loading = true;
    try {
      const res: any = await this.lambdaService.getTemplateData(this.themingService.shopId);
      const rows = Array.isArray(res.data) ? res.data : [];
      this.shopTheme = this.themingService.shopTheming;
      this.logoUrl   = this.shopTheme[0]?.shopLogoLarge || '';

      if (rows.length > 0) {
        this._originalTemplate = { ...rows[0] };
        this.templateData = { ...rows[0] };
        this.onToggleDefault();
      } else {
        this._originalTemplate = null;
        this.templateData = {
          ...this.buildDefaultTemplate(),
          useDefaultTemplate: true
        };
      }
    } catch (err) {
      console.error('Error', err);
    } finally {
      this.loading = false;
    }
  }

  private buildDefaultTemplate(): any {
    const shopName = this.shopTheme[0]?.shopName || 'Mi Tienda';
    const orderNum = '#12345';
    return {
      emailSubject:     `${shopName} - Confirmación de orden - ${orderNum}`,
      storeName:        shopName,
      subject:          'Confirmación de compra',
      greeting:         'Hola cliente, gracias por tu compra.',
      purchasedTitle:   'Tus artículos',
      detailsTitle:     'Detalles',
      ctaText:          'Haz clic aquí para acceder a tus productos.',
      website:          this.shopTheme[0]?.shopDomain || 'https://mitienda.com',
      phone:            this.shopTheme[0]?.phone      || '+1234567890',
      email:            this.shopTheme[0]?.mail       || '',
      showWebsite:      true,
      showPhone:        true,
      showEmail:        true,
      priceLabel:       'Precio',
      quantityLabel:    'Cantidad',
      detailsLabel:     'Detalles',
      downloadPdfLabel: 'Descargar PDF',
      dateLabel:        'Fecha'
    };
  }

  onToggleDefault(): void {
    if (this.templateData.useDefaultTemplate) {
      Object.assign(this.templateData, {
        ...this.buildDefaultTemplate(),
        useDefaultTemplate: true
      });
    } else {
      Object.assign(this.templateData, {
        ...this._originalTemplate!,
        useDefaultTemplate: false
      });
    }
  }

  private isTemplateValid(): boolean {
  const requiredFields = [
    'emailSubject', 'storeName', 'subject', 'greeting',
    'purchasedTitle', 'detailsTitle', 'ctaText',
    'website', 'phone', 'email',
    'priceLabel', 'quantityLabel', 'detailsLabel',
    'downloadPdfLabel', 'dateLabel'
  ];

  for (const field of requiredFields) {
    const value = this.templateData[field];
    if (value === null || value === undefined || value.toString().trim() === '') {
      return false;
    }
  }

  return true;
  }

  saveTemplate(): void {
    this.loading = true;
    this.showErrors = true;

    if (!this.isTemplateValid()) {
      $('#templateRequiredModal').modal('show');
      this.loading = false;
      return;
    }

    const shopId = this.themingService.shopId;
    const source = this.templateData.useDefaultTemplate
      ? this._originalTemplate!
      : this.templateData;

    const body = {
      emailSubject:      source.emailSubject,
      storeName:         source.storeName,
      subject:           source.subject,
      greeting:          source.greeting,
      purchasedTitle:    source.purchasedTitle,
      detailsTitle:      source.detailsTitle,
      ctaText:           source.ctaText,
      website:           source.website,
      phone:             source.phone,
      email:             source.email,
      showWebsite:       source.showWebsite,
      showPhone:         source.showPhone,
      showEmail:         source.showEmail,
      priceLabel:        source.priceLabel,
      quantityLabel:     source.quantityLabel,
      detailsLabel:      source.detailsLabel,
      downloadPdfLabel:  source.downloadPdfLabel,
      dateLabel:         source.dateLabel,
      useDefaultTemplate: this.templateData.useDefaultTemplate
    };

    this.lambdaService.createEmailTemplate(shopId, body)
      .then((res: any) => {
        if (res.status === 200) {
          $('#templateSuccessModal').modal('show');
        } else {
          $('#templateErrorModal').modal('show');
        }
      })
      .catch((err: any) => {
        this._originalTemplate = null;
        this.templateData = this.buildDefaultTemplate();
        $('#templateErrorModal').modal('show');
        console.error('Error', err);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  closeModal() {
    $('#templateSuccessModal').modal('hide');
    $('#templateRequiredModal').modal('hide');
    $('#templateErrorModal').modal('hide');
  }

}
